import { render } from "./whr-project-detail.vue?vue&type=template&id=43682a54&scoped=true"
import script from "./whr-project-detail.vue?vue&type=script&lang=js"
export * from "./whr-project-detail.vue?vue&type=script&lang=js"

import "./whr-project-detail.vue?vue&type=style&index=0&id=43682a54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43682a54"]])

export default __exports__